import history from '__common/modules/history';
import { ActionTypes } from 'actionsConstants';
import { hitApi, ObservableAjax } from '__common/utils/api';
import { PROJECT_NOT_FOUND, REDIRECT_TO_PROJECT } from 'actions';
import { GET_APP_STATUS_SUCCESS, GET_APP_STATUS_FAILURE, SET_APP_REVISION_HISTORY, APP_REVISION_HISTORY_PAYLOAD, EMPTY_APP_ACTION, CLEAR_AURORA_IMPORT, REDIRECT_TO_LITE_PROJECT_SUCCESS } from './appActions';
import { safeOfType as ofType } from '__common/utils/safeOfType';
import { AnyAction, Store } from 'redux';
import { Observable } from 'rxjs';
import { getCurrentTime } from '__common/calculations/currentTime';
import { switchMap, mergeMap, map } from 'rxjs/operators';

export function searchProject(action$: Observable<AnyAction>) {
  return action$.pipe(
    ofType(ActionTypes.SEARCH_PROJECT),
    switchMap((action: AnyAction) =>
      ObservableAjax({
        until$: action$.pipe(ofType(ActionTypes.SEARCH_PROJECT)),
        onSuccess: REDIRECT_TO_PROJECT,
        onError: PROJECT_NOT_FOUND,
        onErrorMessage: 'Project not exist',
        link: hitApi('get', `api/v1/search_project/${action.payload.projectId}/`),
      }),
    )
  );
}

export function copyProject(action$) {
  return action$.pipe(
    ofType(ActionTypes.COPY_PROJECT),
    switchMap((action) => {
      const { projectId, isLite } = action.payload;
      let url = `api/v1/duplicate_project/${projectId}/${getCurrentTime()}`;
      if (isLite) {
        url += '?application=ubuilder_lite';
      }
      return ObservableAjax({
        until$: action$.pipe(ofType(ActionTypes.COPY_PROJECT)),
        onSuccess: isLite ? REDIRECT_TO_LITE_PROJECT_SUCCESS : REDIRECT_TO_PROJECT,
        onErrorMessage: 'Cannot copy project',
        link: hitApi('get', url),
      });
    })
  );
}

export function getAppStatus(action$) {
  return action$.pipe(
    ofType(ActionTypes.GET_APP_STATUS),
    switchMap(action =>
      ObservableAjax({
        until$: action$.pipe(ofType(ActionTypes.GET_APP_STATUS)),
        onSuccess: GET_APP_STATUS_SUCCESS,
        onError: GET_APP_STATUS_FAILURE,
        onErrorMessage: 'Application seems to be offline',
        link: hitApi('get', `api/v1/status/`),
      }),
    )
  );
}

export function getAppVersion(action$: Observable<AnyAction>, state$: Observable<appState>): Observable<any> {
  return action$.pipe(
    ofType(ActionTypes.GET_APP_REVISION_HISTORY),
    switchMap(action =>
      ObservableAjax({
        onSuccess: ({ revision_history }: APP_REVISION_HISTORY_PAYLOAD) => {
          return SET_APP_REVISION_HISTORY(revision_history);
        },
        onErrorMessage: 'Could not fetch app revision',
        link: hitApi('get', `api/v1/revision/`),
      }),
    )
  );
}

// export function auroraProjectImport(action$: Observable<AnyAction>, store: Store<appState>): Observable<any>  {
//   return action$.pipe(ofType(ActionTypes.AURORA_IMPORT)
//     , switchMap(action => 
//       ObservableAjax({
//         // takeUntil: action$.pipe(ofType(ActionTypes.AURORA_IMPORT),
//         onSuccess: CLEAR_AURORA_IMPORT,
//         // onError: PROJECT_NOT_FOUND,
//         onErrorMessage: 'Project not exist',
//         link: hitApi('get', `api/v1/aurora/`),
//       }));
// }
